// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kw","legalMessage":"kx","navLink":"ky","bottomLinkWrapper":"kz","bottomLink":"kA ky"};